export const PLACEHOLDER_CLASSROOM_ID = {
  FROM_TEACHER_PRODUCTS_NAV: 'FROM_TEACHER_PROCUCTS_NAV',
  product: 'product'
};

/**
 * Return `true` if `classroomId` has a known placeholder value such as 'product'.
 *
 * Placeholder classroomIds are not associated with a real classroom, and should
 * **not** be passed to the backend.
 *
 * Having a placeholder classroomId typically indicates we are using a feature
 * that is not associated with a real classroom, such as Course Preview (see PublisherCourse.js).
 */
export const isPlaceholderClassroomId = (classroomId) => {
  const placeholderClassroomIds = Object.values(PLACEHOLDER_CLASSROOM_ID);
  return typeof classroomId !== 'string' || placeholderClassroomIds.includes(classroomId);
};
